import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Loader2 } from 'lucide-react';

interface BulkDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  count: number;
  itemType: string;
  onConfirm: () => void;
  isDeleting: boolean;
  /**
   * Bloco extra antes dos botões. Existe para a devolução de estoque na
   * exclusão de orçamentos: é a ÚNICA janela em que ela pode ser oferecida,
   * porque o delete apaga o vínculo dos movimentos (ver stockDocumentReturn.ts).
   */
  extra?: React.ReactNode;
}

export function BulkDeleteDialog({
  open,
  onOpenChange,
  count,
  itemType,
  onConfirm,
  isDeleting,
  extra,
}: BulkDeleteDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Excluir {count} {itemType}?</AlertDialogTitle>
          <AlertDialogDescription>
            Tem certeza que deseja excluir {count} {itemType}? Essa ação não pode ser desfeita.
          </AlertDialogDescription>
        </AlertDialogHeader>
        {extra}
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isDeleting}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isDeleting ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Excluindo...
              </>
            ) : (
              'Excluir'
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
